import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Provider } from 'react-redux';
import { API_CONFIG } from './constants';
import AppRoutes from './routes/AppRoutes';
import store from './store';
import { ToastProvider } from './contexts/ToastContext';
import './App.css';

const App: React.FC = () => {
  return (
    <Provider store={store}>
      <GoogleOAuthProvider clientId={API_CONFIG.GOOGLE_CLIENT_ID}>
        <ToastProvider>
          <Router>
            <div className="App">
              <AppRoutes />
            </div>
          </Router>
        </ToastProvider>
      </GoogleOAuthProvider>
    </Provider>
  );
};

export default App; 